<div class="sidebar-header">
  <img class="logo" src="{{ headerSvgPath }}" />
</div>
